import { routes as payoutMethodRoutes } from './payout-methods'
import { routes as payoutRoutes } from './payouts'

export const routes = {
  ...payoutMethodRoutes,
  ...payoutRoutes,
}
